import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BlogAuthorModel} from '@shared/models/blog-author.model';

@Component({
    selector: 'app-ask-the-author-button',
    templateUrl: './ask-the-author-button.component.html',
    styleUrls: ['./ask-the-author-button.component.scss'],
    standalone: false
})
export class AskTheAuthorButtonComponent {
  @Input() authors: BlogAuthorModel[] = [];
  @Input() isDisabled = false;
  @Output() clickAskAuthor: EventEmitter<any> = new EventEmitter<any>();

  onAsk(): void {
    this.clickAskAuthor.emit();
  }
}
